import React, { useState } from "react";
import PropTypes from "prop-types";

const PasajeroFormulario = (props) => {
  const {tiposDeDocumento, nacionalidades, pasajero, numero, onPasajeroChange} = props;

  const [formulario, setFormulario] = useState({
    nombre: "",
    apellido: "",
    documento: "",
    telefono: "",
    fechaNacimiento: "",
    sexo: "M",
  });

  const handleInputChange = (e) => {
    let formularioClone = Object.assign({}, formulario);
    formularioClone[e.target.name] = e.target.value;

    if (e.target.name === "documento" || e.target.name === "telefono") {
      if (!/^\d*$/.test(e.target.value)) {
        return false;
      }
    }

    onPasajeroChange(
      numero,
      e.target.name,
      e.target.value
    );

    setFormulario(formularioClone);
  };

  const handleTipoDocumentoChange = (e) => {
    let idTipoDocumento = e.target.value;
    onPasajeroChange(
      props.numero,
      e.target.name,
      tiposDeDocumento.find(
        (e) => e.idTipoDocumento === idTipoDocumento
      )
    );
  };

  const handleNacionalidadChange = (e) => {
    let idNacionalidad = e.target.value;
    onPasajeroChange(
      numero,
      e.target.name,
      nacionalidades.find((e) => e.id === idNacionalidad)
    );
  };

  const traerTipoDoc = () => {
    if (pasajero.tipoDocumento)
      return pasajero.tipoDocumento.idTipoDocumento;
  };

  const traerNacionalidadElegida = () => {
    if (pasajero.nacionalidad)
      return pasajero.nacionalidad.id;
  };

  return (
    <form
      action="#"
      method="post"
      className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 datos-personales clearfix"
    >
      <div className="fieldset row bg">
        <Titulo pasajero={pasajero} numero={numero} />
        {/*<input type="text" name="nombre" placeholder="Nombre" onChange={this.handleInputChange} />*/}
        <div className="input-container col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
          <label htmlFor="nombre">
            Nombres
            <sup>*</sup>
          </label>
          <input
            className={!formulario.nombre ? "error" : ""}
            type="text"
            name="nombre"
            onChange={handleInputChange}
            placeholder="Nombre completo como figura en el DNI"
          />
        </div>
        {/*<FormInput label="Nombre:" name="nombre" placeholder="Nombre" valueLink={nombreLink} type="text" onChange={this.handleInputChange} />
                  <input type="text" name="apellido" placeholder="Apellido" onChange={this.handleInputChange} />*/}
        <div className="input-container col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
          <label htmlFor="apellido">
            Apellido
            <sup>*</sup>
          </label>
          <input
            className={!formulario.apellido ? "error" : ""}
            type="text"
            name="apellido"
            onChange={handleInputChange}
            placeholder="Apellido completo como figura en el DNI"
          />
        </div>
        {/*  <FormInput label="Apellido:" name="apellido" placeholder="Apellido" valueLink={apellidoLink} type="text" onChange={this.handleInputChange} /> */}
        <div className="input-container col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 row">
          <label className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            Tipo y n&uacute;mero de documento
            <sup>*</sup>
          </label>
          <div className="col-xl-3 col-lg-3 col-md-5 col-sm-5 col-5 select-container">
            <select
              name="tipoDocumento"
              value={traerTipoDoc()}
              onChange={handleTipoDocumentoChange}
            >
              {tiposDeDocumento.map((tipoDeDocumento) => {
                return (
                  <option
                    key={tipoDeDocumento.idTipoDocumento}
                    value={tipoDeDocumento.idTipoDocumento}
                  >
                    {tipoDeDocumento.sigla}
                  </option>
                );
              })}
            </select>
          </div>
          <input
            className={
              !formulario.documento
                ? "col-xl-8 col-lg-8 col-md-5 col-sm-6 col-6 error"
                : "col-xl-8 col-lg-8 col-md-5 col-sm-6 col-6"
            }
            type="text"
            onChange={handleInputChange}
            style={{ marginLeft: "8%" }}
            name="documento"
            value={formulario.documento}
            placeholder="N&uacute;mero de documento"
          />
        </div>

        {/*  <select name="tipoDocumento" value={this.traerTipoDoc()} onChange={this.handleTipoDocumentoChange}>
                    {
                      tiposDeDocumento.map((tipoDeDocumento, indice) => {
                        return <option key={tipoDeDocumento.idTipoDocumento} value={tipoDeDocumento.idTipoDocumento}>{tipoDeDocumento.sigla}</option>
                      })
                    }
                  </select>
                  <FormInput label="Documento:" name="documento" placeholder="N° Documento" valueLink={documentoLink} type="text" onChange={this.handleInputChange} />
                  <input type="text" name="documento" placeholder="Numero Documento" onChange={this.handleInputChange} />*/}
        <div className="input-container col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 row">
          <label htmlFor="fechaNacimiento">
            Fecha Nacimiento
            <sup>*</sup>
          </label>
          <input
            className={!formulario.fechaNacimiento ? "error" : ""}
            type="date"
            name="fechaNacimiento"
            placeholder="Fecha Nacimiento"
            onChange={handleInputChange}
          />
        </div>

        <div className="input-container col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 row">
          <label className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            Sexo y Telefono
            <sup>*</sup>
          </label>
          <div className="col-xl-3 col-lg-3 col-md-5 col-sm-5 col-5 select-container">
            <select
              value={formulario.sexo}
              name="sexo"
              onChange={handleInputChange}
            >
              <option value="M">Masculino</option>
              <option value="F">Femenino</option>
            </select>
          </div>
          <input
            className={
              !formulario.telefono
                ? "col-xl-8 col-lg-8 col-md-6 col-sm-6 col-6 error"
                : "col-xl-8 col-lg-8 col-md-6 col-sm-6 col-6"
            }
            type="text"
            name="telefono"
            value={formulario.telefono}
            onChange={handleInputChange}
            style={{ marginLeft: "8%" }}
            placeholder="Telefono (sin guiones)"
          />
        </div>

        {/*<FormInput label="Telefono:" name="telefono" placeholder="Telefono" valueLink={telefonoLink} type="text" onChange={this.handleInputChange} />
                <input type="text" name="telefono" placeholder="Telefono" onChange={this.handleInputChange} />
                  <select value="" name="sexo" onChange={this.handleInputChange}>
                      <option value="M">Masculino</option>
                      <option value="F">Femenino</option>
                  </select>*/}
        <div className="input-container col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
          <label htmlFor="nacionalidad">
            Nacionalidad
            <sup>*</sup>
          </label>
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 select-container">
            <select
              value={traerNacionalidadElegida()}
              name="nacionalidad"
              onChange={handleNacionalidadChange}
            >
              {nacionalidades.map((nacionalidad) => {
                return (
                  <option key={nacionalidad.id} value={nacionalidad.id}>
                    {nacionalidad.denominacion}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      </div>
    </form>
  );
};

export default PasajeroFormulario;

function Titulo(props) {
  const pasajero = props.pasajero;
  const numero = props.numero;
  if (pasajero.tipoPasajero === "Menor")
    return (
      <h5 className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        Pasajero {pasajero.tipoPasajero} de {pasajero.edad} años{" "}
      </h5>
    );

  return (
    <h5 className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      Pasajero {pasajero.tipoPasajero} {numero + 1}{" "}
    </h5>
  );
}

PasajeroFormulario.propTypes = {
  tiposDeDocumento: PropTypes.array,
  nacionalidades: PropTypes.array,
  pasajero: PropTypes.object,
  numero: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/CargaPasajeros/PasajeroFormulario/index.js